import { Dispatch, SetStateAction } from 'react'
import { useQuery } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { validateBic } from 'services/BeneficiaryService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { MappedErrorMessageState } from 'types/errors'

export const useBicValidation = (
  bic: string,
  setRequestError: Dispatch<SetStateAction<MappedErrorMessageState>>,
  enabled = false
) => {
  return useQuery(reactQueryKeys.validateBic(bic), () => validateBic(bic), {
    enabled: enabled,
    onError: (error: BaseErrorResponse) => {
      error?.status !== 400 && logSentryError('Error: useBicValidation', error, { bic })

      setRequestError({
        errorCode: error.status,
        show: true,
      })
    },
    cacheTime: 0,
  })
}
